import { FC, useEffect, useRef } from 'react';

import styles from './Header.module.css';
import { animations, attachAnimations, interactiveStyle } from '../../utils/interactions';
import Icon from '../Icon/Icon';
import ScrollPrompt from '../ScrollPrompt/ScrollPrompt';

const Header: FC = () => {
  const logoIconRef = useRef<HTMLDivElement>(null);
  const titleRef = useRef<HTMLHeadingElement>(null);
  const taglineRef = useRef<HTMLParagraphElement>(null);

  useEffect(() => {
    const cleanup = attachAnimations([
      {
        element: logoIconRef.current,
        animation: animations.rotate360(logoIconRef.current!),
        triggers: ['hover', 'touch'],
      },
      {
        element: titleRef.current,
        animation: animations.gentleBounce(titleRef.current!),
        triggers: ['click', 'touch'],
      },
      {
        element: taglineRef.current,
        animation: animations.rock(taglineRef.current?.querySelectorAll('.taglineIcon') || []),
        triggers: ['hover', 'touch'],
      },
    ]);

    return cleanup;
  }, []);

  return (
    <header className={styles.header} role="banner">
      <div className={styles.content}>
        <div className={styles.logoContainer}>
          <div ref={logoIconRef} style={interactiveStyle}>
            <Icon
              icon="mdi:cellphone-link"
              className={styles.headerIcon}
              size="xl"
              aria-hidden={true}
              aria-label="Mobile App Development Icon"
            />
          </div>
          <h1 ref={titleRef} className={styles.title} style={interactiveStyle}>
            Sara England
          </h1>
          <p
            ref={taglineRef}
            className={styles.tagline}
            aria-label="Professional role"
            style={interactiveStyle}
          >
            <Icon
              icon="mdi:code-braces"
              className={`${styles.taglineIcon} taglineIcon`}
              size="md"
              aria-hidden={true}
              aria-label="Code Development Icon"
            />{' '}
            Mobile App Developer & UX Guru
            <Icon
              icon="mdi:palette"
              className={`${styles.taglineIcon} taglineIcon`}
              size="md"
              aria-hidden={true}
              aria-label="UX Design Icon"
            />
          </p>
        </div>
      </div>
      <div className={styles.scrollPromptWrapper}>
        <ScrollPrompt targetId="hero" label="Next" showIcon={true} />
      </div>
    </header>
  );
};

export default Header;
